// extracted by mini-css-extract-plugin
export default {"row":"AffiliateCenter_row__lGMTP","col":"AffiliateCenter_col__BmKel","card":"AffiliateCenter_card__crcF7"};